import { useEffect, useRef, useState } from 'react'

export const useHoldAfter = (trigger: number | undefined, holdMs: number): boolean => {
  const [held, setHeld] = useState(false)
  const prevTriggerRef = useRef<number | undefined>(trigger)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (trigger === undefined) {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
      prevTriggerRef.current = undefined
      setHeld(false)
      return
    }
    if (trigger === prevTriggerRef.current) {
      return
    }
    prevTriggerRef.current = trigger
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current)
    }
    setHeld(true)
    timerRef.current = setTimeout(() => {
      timerRef.current = null
      setHeld(false)
    }, holdMs)
    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [trigger, holdMs])

  return held
}
